import BaseAddress from '../../_base/functions/baseAddress';
import isNil from '../../_base/functions/isNil';

// returns an address (string)
export default function ApiAddresses(settings) {
  const host = BaseAddress();
  let address;

  switch (settings.name) {
    // list of all templates
    case 'templates':
      return host + '/templates.json';
    // a single template
    case 'template':
      return host + '/templates/' + settings.id + '.json';
    case 'wbs_item_details':
      return (
        host +
        '/projects/' +
        settings.project_id +
        '/wbs_items/' +
        settings.id +
        '.json'
      );
    case 'current_project':
      return host + '/projects/current.json';
    case 'bottom-navigation':
      return host + '/projects/' + settings.project_id + '/navigation';
    case 'get_upload_href':
      return host + '/ape_uploads';
    case 'get_action_type':
      return host + '/actions/' + settings.action_id + '/action_type';
    case 'mapping_features':
      address =
        host +
        `/mapping_features?project=${settings.project_id}&from=${settings.fromDate}&to=${settings.toDate}`;
      if (settings.templates) {
        address += `&templates=${settings.templates}`;
      }
      if (settings.users) {
        address += `&users=${settings.users}`;
      }
      return address;
    case 'project_activity':
      address =
        host + '/projects/' + settings.project_id + '/activity_summary.json';
      if (settings.templates) {
        if (address.indexOf('?') > -1) {
          address += `&templates=${settings.templates}`;
        } else {
          address += `?templates=${settings.templates}`;
        }
      }
      if (settings.users) {
        if (address.indexOf('?') > -1) {
          address += `&users=${settings.users}`;
        } else {
          address += `?users=${settings.users}`;
        }
      }
      return address;
    case 'live_feed':
      address =
        host +
        `/projects/${settings.project_id}/live_view_newsfeed.json?from=${settings.fromDate}&to=${settings.toDate}`;
      if (settings.templates) {
        address += `&templates=${settings.templates}`;
      }
      if (settings.users) {
        address += `&users=${settings.users}`;
      }
      return address;
    case 'users_by_project':
      return host + `/projects/${settings.project_id}/project_members.json`;
    case 'templates_by_project':
      return (
        host +
        `/projects/${settings.project_id}/templates_in_use.json&?type=all`
      );
    case 'procore_authorized_user':
      return host + `/procore/authorized_user`;
    case 'procore_company_details':
      return (
        host +
        `/procore/companies/${settings.company_id}/users/${settings.user_id}`
      );
    case 'subdomain_check':
      let modifiedHost = window.location.hostname.split('.');
      return `${window.location.protocol}//admin.${modifiedHost[1]}.${modifiedHost[2]}/api/v1/available_subdomains/${settings.domain_value}`;
    case 'create_ape_server_procore':
      return host + '/procore/create_trial';
    case 'procore_projects':
      return (
        host + `/procore/companies/${settings.company_id}/active_projects.json`
      );
    case 'procore_users':
      if (
        !isNil(settings.selectedProjectsArray) &&
        settings.selectedProjectsArray.length > 0
      ) {
        const projectsString = settings.selectedProjectsArray.join(',');
        return (
          host +
          `/procore/companies/${settings.company_id}/active_users?projects=${projectsString}`
        );
      }
      return host + `/procore/companies/${settings.company_id}/active_users`;
    case 'billing_licenses':
      return host + `/billing/licenses`;
    case 'billing_estimates':
      return host + `/billing/estimate`;
    case 'billing_update':
      return host + `/billing`;
    case 'user_data':
      if (settings.type) {
        return (
          host + `/users/${settings.id}/show_admin.json?type=${settings.type}`
        );
      }
      return host + `/users/${settings.id}/show_admin.json`;
    case 'user_password_update':
      return host + `/users/${settings.id}/update_password.json`;
    case 'users_list':
      return host + `/users.json`;
    case 'project_data':
      return host + `/projects/${settings.id}/show_admin.json`;
    case 'project_save':
      return host + `/projects/${settings.id}`;
    case 'org_list_with_items':
      return `${host}/organisation_lists/${settings.id}.json?items=true`;
    case 'org_list':
      return `${host}/organisation_lists/${settings.id}.json`;
    default:
      return null;
  }
}
